


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CardRow from '@/components/CardRow.vue';
import { REMOVE_VOUCHER } from '../../../store/financeAccount';
import { RemoveVoucher, Transaction } from '../../../types';
import { ApiResponse } from '@/components/types';
import { createRemoveVoucher } from '@/modules/listOfAssets/model';
import HtmlRow from '@/components/HtmlRow.vue';

const FinanceAccount = namespace('listOfAssets/financeAccount');

@Component({
  components: {
    HtmlRow,
    CardRow
  }
})
export default class RemoveVoucherDialog extends Vue {
  @Prop({ type: Object }) transaction!: Transaction;

  @FinanceAccount.Action(REMOVE_VOUCHER) removeVoucher!: (value: RemoveVoucher) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;
  value: RemoveVoucher | null = null;

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value !== false) return;

    setTimeout(() => {
      this.error = null;
      this.dialog = false;
      this.value = null;
      this.$emit('update:transaction', null);
    }, 200);
  }

  @Watch('transaction')
  watchTransaction(transaction: Transaction) {
    if (!transaction) return;

    this.value = createRemoveVoucher(transaction);

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  async save() {
    if (!this.value) return;

    this.error = null;

    return this.removeVoucher(this.value);
  }
}
